// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 42\"><path d=\"M29.1,31.8H14.4a6.3,6.3,0,0,1,0-12.6h.7a8.6,8.6,0,0,1,7.7-4.8,8.7,8.7,0,0,1,8.6,7.8,4.9,4.9,0,0,1,2.7,4.5A5,5,0,0,1,29.1,31.8ZM14.4,20.4a5.1,5.1,0,0,0,0,10.2H29.1a3.9,3.9,0,0,0,1.5-7.5.7.7,0,0,1-.4-.5A7.4,7.4,0,0,0,16,20.1a.7.7,0,0,1-.7.4Z\"/></svg>";
// Exports
module.exports = code;